export const agencies = [
  {
    id: 'wanderlust',
    name: 'African Travel Service',
    logo: 'https://scontent.fcdg3-1.fna.fbcdn.net/v/t1.6435-9/120032476_10158144356923025_943805609750510116_n.png?_nc_cat=108&ccb=1-7&_nc_sid=1d70fc&_nc_ohc=Bqr-58zD2WEQ7kNvgFNWL8b&_nc_zt=23&_nc_ht=scontent.fcdg3-1.fna&_nc_gid=AYGqzmd1gtDKP-UN6JblvMa&oh=00_AYAKQQH1HLtHokSr-MfCzEmJbO8sDWV8iUiBZXfB6Eovfw&oe=6769C7B5',
    rating: 4.8,
    reviewCount: 1250,
    verified: true,
    theme: {
      primaryColor: '#1e3a8a',
      secondaryColor: '#1d4ed8',
      accentColor: '#f97316',
      textColor: '#111827',
      backgroundColor: '#f8fafc',
      headerStyle: 'default',
      font: 'poppins',
    }
  },
  {
    id: 'globetrotter',
    name: '1001 Voyages',
    logo: 'https://scontent.fcdg3-1.fna.fbcdn.net/v/t39.30808-6/309246052_513011244162703_4301285600100033374_n.jpg?_nc_cat=111&ccb=1-7&_nc_sid=6ee11a&_nc_ohc=gfu8pVPSs20Q7kNvgEH24Yd&_nc_zt=23&_nc_ht=scontent.fcdg3-1.fna&_nc_gid=AWPBSmH6LDc0YmWwQkv41ip&oh=00_AYBjjPGQ2d8JlFeGwrf2U0TkjLGORKUdHUvxBa37uuuimA&oe=6748225C',
    rating: 4.9,
    reviewCount: 2150,
    verified: true,
    description: "Spécialiste des voyages Omra depuis plus de 15 ans, 1001 Voyages s'engage à vous offrir une expérience spirituelle inoubliable avec un service haut de gamme et une attention particulière à chaque détail.",
    theme: {
      primaryColor: '#1A1A1A', // Noir profond pour un look luxueux
      secondaryColor: '#2A2A2A', // Noir plus clair pour les éléments secondaires
      accentColor: '#C0A080', // Or/Bronze subtil pour les accents
      textColor: '#333333', // Gris foncé pour le texte principal
      backgroundColor: '#FFFFFF', // Blanc pur pour le fond
      headerStyle: 'centered',
      font: 'montserrat', // Police élégante et moderne
    }
  }
] as const;